import React from 'react'
import { motion } from 'framer-motion'

const EngagementSection = () => {
  const stages = [
    {
      title: "Fixed Scope Fixed Price",
      points: [
        "Predefined cost and timeline.",
        "No hidden charges.",
        "Best for small, well-defined projects."
      ],
    },
    {
      title: "Time & Material",
      points: [
        "Flexible pricing based on work.",
        "Full control over changes.",
        "Ideal for evolving projects."
      ],
    },
    {
      title: "Dedicated Team",
      points: [
        "Exclusive team for your project.",
        "Direct communication & control.",
        "Best for long-term projects."
      ],
    },
    {
      title: "Offshore Developers",
      points: [
        "Cost-effective, high-quality work.",
        "Skilled developers as per needs.",
        "24/7 productivity with time zone advantage."
      ],
    },
  ];

  const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    hover: { scale: 1.05 }
  };

  return (
    <div className='flex flex-col items-center justify-center p-2 lg:p-10 max-w-7xl mx-auto gap-y-10 text-center mt-5 lg:mt-10'>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        variants={fadeUp}
        className="space-y-4"
      >
        <h1 className='font-extrabold text-2xl lg:text-4xl text-gray-700'>Engagement models</h1>
        <p className='font-semibold text-xl lg:text-2xl text-gray-700'>
          Explore our verstatile engagement models for seamless collaboration and project success
        </p>
      </motion.div>

      <div className='grid grid-cols-1 relative md:grid-cols-2 xl:grid-cols-4 gap-3'>
        {stages.map((stage, index) => (
          <motion.div
            key={index}
            className="p-5 rounded-3xl bg-gray-100 border border-transparent hover:border hover:border-primaryColor cursor-pointer transition duration-300 ease-in-out hover:-translate-y-2 hover:shadow-2xl"
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            whileHover="hover"
          >
            <h1 className="text-4xl font-semibold text-gray-800">{stage.title}</h1>
            <hr className='my-2' />
            <ul style={{ listStyleType: 'disc' }} className="text-lg text-gray-700">
              {stage.points.map((point, idx) => (
                <li key={idx} className="text-start mx-5 text-gray-700">{point}</li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default EngagementSection
